import { t } from 'i18next';
import { ReactComponent as HoverToZoom } from '../../../../assets/icons/hover-to-zoom-new.svg';
import { Page } from '../../../../enums/page';
import { mobileAndTabletDetection } from '../../../../utils/browser';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import './index.scss';

export const HoverToZoomContainer = () => {

    const {
        applicationState: { currentPage },
      } = useSelector((state: RootState) => state);

    const isMobileDevice = mobileAndTabletDetection();

    return <div className="hover-to-zoom-container">
        <HoverToZoom />
        <span className={`hover-to-zoom-text ${currentPage || ''}`}>
            {isMobileDevice 
                ? t('shopping_cart_details.tapToZoom') 
                : t(`shopping_cart_details.${
                    currentPage === Page.ORDERCONFIRMATION || currentPage === Page.ORDERDETAILS ? 'clickToZoom' : 'hoverToZoom'
                }`)}
        </span>
    </div>

}

